<div class="flex flex-row h-full mic-login">
  <div class="flex flex-col justify-center items-center h-full grow-1 gap-14">
    <div>
      <h1>HBI Application</h1>
    </div>
    <div>
      <div>
        <button (click)="login()" mat-flat-button color="primary" class="mic-login-button">Login</button>
      </div>
    </div>
    <div class="flex flex-row items-center gap-4 mic-login-footer">
      <p>Powered by</p>
      <mic-logo type="group" link="michelin.fr" ariaLabel="Michelin.fr" target="_blank"></mic-logo>
    </div>
  </div>
  <div class="md-hidden" [ngClass]="{ 'mic-login-trapeze': !image, 'mic-login-image': image, 'w-4on12': !image, 'w-1on2': image }"></div>
</div>
